import React from 'react'

import { Flex } from '@driftt/dds'

import { ActivityContext, ActivityType } from 'modules/accountActivity/domain'
import { getSignalString } from 'utils/activity'

interface GenericContentProps {
  activityType: ActivityType
  activityContext: ActivityContext
}

export const GenericContent = ({ activityType, activityContext }: GenericContentProps) => {
  const contentSwitch = () => {
    switch (activityType) {
      case ActivityType.FILLED_OUT_FORM:
        return activityContext.driftSfdcTask?.subject ?? 'Filled out a form'
      case ActivityType.UNSUBSCRIBED: {
        const subject = activityContext.driftSfdcTask?.subject?.toLowerCase()
        const capitalized = subject ? subject.charAt(0).toUpperCase() + subject.slice(1) : undefined
        return capitalized ? capitalized : 'Unsubscribed'
      }
      case ActivityType.END_USER_IDENTIFIED:
        return 'End user identified'
      case ActivityType.OTHER_CHATBOT_CONVERSATION:
        return activityContext.driftSfdcTask?.subject ?? 'Other chatbot conversation'
      case ActivityType.CONTRACT_REQUEST:
        return activityContext.driftSfdcTask?.subject ?? 'Contract request'
      case ActivityType.SMS_INBOUND:
        return activityContext.driftSfdcTask?.description ?? 'Sent SMS'
      case ActivityType.WEBINAR:
        return 'Webinar lead'
      case ActivityType.ADDED:
        return 'Contact added'
      case ActivityType.SIGNAL: {
        return getSignalString(activityContext).split('|||')[0]
      }
      default:
        return ''
    }
  }

  return (
    <Flex direction="column" css={{ paddingTop: '16px' }}>
      {contentSwitch()}
    </Flex>
  )
}
